import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

interface QAItem {
  id: number;
  question: string;
  answer: string;
  isExpanded: boolean;
}

@Component({
    selector: 'app-qa',
    templateUrl: './qa.component.html',
    styleUrls: ['./qa.component.scss'],
    imports: [TranslateModule],
})
export class QaComponent implements OnInit {
  qaItems: QAItem[] = [
    {
      id: 1,
      question: 'HOME.QA.Q1_QUESTION',
      answer: 'HOME.QA.Q1_ANSWER',
      isExpanded: false
    },
    {
      id: 2,
      question: 'HOME.QA.Q2_QUESTION',
      answer: 'HOME.QA.Q2_ANSWER',
      isExpanded: false
    },
    {
      id: 3,
      question: 'HOME.QA.Q3_QUESTION',
      answer: 'HOME.QA.Q3_ANSWER',
      isExpanded: false
    },
    {
      id: 4,
      question: 'HOME.QA.Q4_QUESTION',
      answer: 'HOME.QA.Q4_ANSWER',
      isExpanded: false
    },
    // {
    //   id: 5,
    //   question: 'Can I update the content after ordering?',
    //   answer: 'Currently, the content is permanently embedded during manufacturing to ensure the best quality and durability. However, we\'re working on future versions that may allow content updates.',
    //   isExpanded: false
    // },
    // {
    //   id: 6,
    //   question: 'What photo formats do you accept?',
    //   answer: 'We accept JPEG and PNG formats. For the best results, use high-resolution images (at least 1080p) with good lighting. Our editor helps you crop and adjust your photo to look perfect on the magnet.',
    //   isExpanded: false
    // },
    // {
    //   id: 7,
    //   question: 'How long does shipping take?',
    //   answer: 'Standard shipping takes 5-7 business days within the EU. We also offer express shipping options for faster delivery. You\'ll receive tracking information once your order is processed.',
    //   isExpanded: false
    // },
    // {
    //   id: 8,
    //   question: 'Do you offer bulk discounts?',
    //   answer: 'Yes! We offer special pricing for bulk orders of 10 or more magnets. Contact our customer service team for a custom quote on larger quantities.',
    //   isExpanded: false
    // }
  ];

  constructor() { }

  ngOnInit(): void {
  }

  toggleExpanded(item: QAItem): void {
    item.isExpanded = !item.isExpanded;
  }

  trackByFn(index: number, item: QAItem): number {
    return item.id;
  }
}
